// assets/src/js/alpine/components/familySelect.js
export function familySelect(Alpine) {
  Alpine.data('familySelect', (opts = {}) => ({
    open: false,
    activeIndex: -1,
    items: opts.items || [], // [{ label, url }]
    target: opts.target || '_self', // '_blank'도 가능

    toggle() {
      this.open = !this.open;
      if (this.open) this.$nextTick(() => this.$refs.panel?.focus());
    },
    close() {
      this.open = false;
      this.activeIndex = -1;
    },
    go(url) {
      if (url) {
        window.open(url, this.target);
        this.close();
      }
    },

    onButtonKey(e) {
      if (['ArrowDown', 'Enter', ' '].includes(e.key)) {
        e.preventDefault();
        this.open = true;
        this.$nextTick(() => this.$refs.panel?.focus());
      }
    },
    onListKey(e) {
      if (e.key === 'Escape') return this.close();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.activeIndex = (this.activeIndex + 1) % this.items.length;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.activeIndex =
          (this.activeIndex - 1 + this.items.length) % this.items.length;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        this.go(this.items[this.activeIndex]?.url);
      }
    },
  }));
}
